var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEtoileCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 85,
    viewBox: "0 0 89 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3998 66.7L20.5998 79.2L25.0998 52.7001L5.7998 33.9001L32.4998 30L44.3998 5.80005L56.2998 30L82.9998 33.9001L63.6998 52.7001L68.1998 79.2L44.3998 66.7Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4001 5.8L56.3001 30L83.0001 33.9L63.7001 52.7L68.3001 79.2L44.4001 66.7L20.6001 79.2L25.2001 52.7L5.80007 33.9L32.5001 30L44.4001 5.8ZM44.4001 0C42.2001 0 40.1001 1.3 39.2001 3.3L28.6001 24.7L5.00007 28.1C2.80007 28.4 1.00007 30 0.300068 32.1C-0.399932 34.2 0.200068 36.5 1.80007 38.1L18.9001 54.8L14.9001 78.3C14.5001 80.5 15.4001 82.7 17.2001 84C18.2001 84.7 19.4001 85.1 20.6001 85.1C21.5001 85.1 22.5001 84.9 23.3001 84.4L44.4001 73.3L65.5001 84.4C66.4001 84.8 67.3001 85.1 68.2001 85.1C69.4001 85.1 70.6001 84.7 71.6001 84C73.4001 82.7 74.3001 80.5 73.9001 78.3L69.9001 54.8L87.1001 38C88.7001 36.4 89.3001 34.1 88.6001 32C87.9001 29.9 86.1001 28.3 83.9001 28L60.3001 24.6L49.6001 3.3C48.7001 1.3 46.6001 0 44.4001 0Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8001 54.7L18.6001 55.7C20.5001 55.5 22.5001 55.2 24.7001 54.9L25.1001 52.7L5.80007 33.9L32.5001 30L44.4001 5.8L56.3001 30L76.8001 33C78.9001 31.4 81.0001 29.8 83.1001 28L60.3001 24.7L49.6001 3.3C48.6001 1.3 46.6001 0 44.4001 0C42.2001 0 40.1001 1.3 39.2001 3.3L28.6001 24.7L5.00007 28.1C2.80007 28.4 1.00007 30 0.300068 32.1C-0.399932 34.2 0.200068 36.5 1.80007 38.1L18.8001 54.7Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 59C37.2998 57 58.9998 51.1 82.7998 34L82.8998 33.9001L56.2998 30L44.3998 5.80005L32.4998 30L5.7998 33.9001L25.0998 52.7001L23.9998 59Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.8,
    height: 85,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtoileCurrent);
export default __webpack_public_path__ + "static/media/EtoileCurrent.8c43ab39fb0e24a232c71ba6bbea06e4.svg";
export { ForwardRef as ReactComponent };